import React from 'react';
import { GetStaticProps } from 'next';
import { withTheme } from '@emotion/react';
import { getStaticPropsResorts } from '@layout/get-page-props';
import { ResortsPageLayout, ResortsPageLayoutProps } from '@layout/ResortsPageLayout/ResortsPageLayout';
import { withGlobalProvider } from 'providers/globalProvider';
import { ContentApi } from '@model/iceberg/service/content';
import { Revalidate } from '@model/config/revalidate';
import { Page, TripTypes } from '@model/common';
import { PageTemplates } from '@model/content';
import { storeWrapper } from '@state/store';
import { DestinationLevel, getDestinationPagePaths } from '@util/get-destination-static-paths';

const ResortsRegionPage = (props: ResortsPageLayoutProps) => {
  return <ResortsPageLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async ({ params }: any) => ({
  ...(await getStaticPropsResorts({ store, params })),
  revalidate: Revalidate.HALF_HOUR
}));

export async function getStaticPaths() {
  const destinationPages = await new ContentApi().getPageConfigMap({ template: PageTemplates.DESTINATION });
  const paths = getDestinationPagePaths({
    destinationPages,
    level: DestinationLevel.REGION,
    tripType: TripTypes.HOLIDAYS,
    suffix: Page.RESORTS
  });

  return { paths, fallback: false };
}

export default withGlobalProvider(withTheme(ResortsRegionPage));
